<template>
  <BreadCrumb page="Beranda > Pendaftaran > Asesmen > Pengaturan Jadwal Asesmen"></BreadCrumb>
  <div class="container content-area">
    <div class="row">
      <div class="col-12">
        <h3 class="judul-seksi-sga">Pengaturan Jadwal Asesmen PSB Tahun Ajaran {{this.$store.getters.getTahunAJaran}}</h3>
        <LoadSpinner v-if="loading"></LoadSpinner>
        <hr>
        <div class="notes-notification-sga">
          <p><strong>Catatan : </strong></p>
          <ul>
            <li>Masukkan tanggal jadwal asesmen</li>
            <li>Sesi #1 : 08.00-09.30</li>
            <li>sesi#2 : 10.15 - 11.45</li>
        </ul>
        </div>
        <form>
          <div class="form-general">
            <div class="row">
              <div class="col-12">
                <div class="table-responsive">
                  <table class="table table-striped ">
                    <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Hari</th>
                      <th scope="col">Tanggal</th>
                      <th scope="col">Sesi</th>
                      <th scope="col"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(assesor,idx) in dataAssesor" :key="idx">
                      <td scope="row">{{assesor.no}}</td>
                      <td>{{assesor.hari}}</td>
                      <td>{{assesor.tanggal}}</td>
                      <td>{{assesor.sesi_waktu}}</td>
                      <td>
                        <a @click="deleteAssessor(assesor.id_assessment)" href="#"><i class="fa-solid fa-trash"></i></a>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div></div>
            <hr>
            <h4>Tambah Jadwal</h4>
            <div class="row">
              <div class="col-md-11" v-if="messagetrx">
                <AlertSuccess v-if="successtrx" :message="messagetrx"></AlertSuccess>
                <AlertDanger v-else :message="messagetrx"></AlertDanger>
              </div>
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-3 spacer-field-sga">
                    <div class="datepicker date input-group">
                      <input type="date" placeholder="" v-model="tanggal" class="w-100 form-control" required="">
                    </div>
                    <keterangan-form :class="v$.tanggal.$error?'text-danger':''">tekan simbol kalendar, pilih bulan, hari & tanggal</keterangan-form>
                  </div>
                  <div class="col-md-6 spacer-field-sga">
                    <label>Sesi:</label>
                    <select v-model="sesikelas" class="form-control ml-2" placeholder="Pilih Sesi">
                      <option value="sesi#1">Sesi #1</option>
                      <option value="sesi#2">Sesi #2</option>
                    </select>
                  </div>
                  <div class="col-md-3 button-area-sga text-left">
                    <LoadSpinner v-if="loading"></LoadSpinner>
                    <button v-else type="button" @click="saveDataAssessment" class="btn btn-md btn-success"><i class="fa-solid fa-caret-right"></i>  Tambah jadwal</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import useValidate from '@vuelidate/core'
import BreadCrumb from "@/components/BreadCrumb";
import DashboardServices from "@/services/dashboard.services";
import {required,minLength,} from '@vuelidate/validators';
import AlertDanger from "@/components/AlertDanger";
import AlertSuccess from "@/components/AlertSuccess";
import LoadSpinner from "@/components/LoadSpinner";
export default {
  name: "PengaturanJadwalAssessment",
  components: {LoadSpinner, AlertSuccess, BreadCrumb,AlertDanger},
  data:()=>({
    v$: useValidate(),
    loading: false,
    response: '',
    message: '',
    success: false,
    messagetrx: '',
    successtrx: false,
    tanggalkelas:'',
    anggota:'',
    tanggal:'',
    sesikelas:'',
    dataAssesor:[]
  }),
  methods:{
    getDataAssessor(){
      this.loading = true;
      this.$store.commit('loading',this.loading);
      let data = this.lazyParams;
      let path = '/dashboard/getDataAssessment';
      DashboardServices.postData(data,path).then(
          (response)=>{
            this.response = response.data;
            this.message = response.data.message;
            if(response.data.status===200){
              this.success = true;
              this.dataAssesor = this.response.data;
            }else {
              this.success = false;
            }
            this.loading = false;
            this.$store.commit('loading',this.loading);
          }
      );
    },
    async saveDataAssessment(){
      const result = await this.v$.$validate();
      if(result){
        this.loading = true;
        this.$store.commit('loading',this.loading);
        let data = {
          tanggal: this.tanggal,
          sesikelas: this.sesikelas,
        };
        let path = '/dashboard/simpanAssessment';
        DashboardServices.postData(data,path).then(
            (response)=>{
              this.response = response.data;
              this.messagetrx = response.data.message;
              if(response.data.status===200){
                this.successtrx = true;
                this.getDataAssessor();
              }else {
                this.successtrx = false;
              }
              this.loading = false;
              this.$store.commit('loading',this.loading);
            }
        );
      }else{
        this.message = 'Silahkan isi data dengan benar';
      }
    },
    deleteAssessor(idAssesor){
      this.loading = true;
      this.$store.commit('loading',this.loading);
      let data = {
        paramname: idAssesor,
        status: 'ACTIVE'
      };
      let path = '/dashboard/deleteAssessment';
      DashboardServices.postData(data,path).then(
          (response)=>{
            this.response = response.data;
            this.messagetrx = response.data.message;
            if(response.data.status===200){
              this.successtrx = true;
              this.getDataAssessor();
            }else {
              this.successtrx = false;
            }
            this.loading = false;
            this.$store.commit('loading',this.loading);
          }
      );
    },
  },
  validations(){
    return {
      tanggal:{required,minlength:minLength(5)},
    }
  },
  mounted() {
    this.getDataAssessor();
  }
}
</script>

<style scoped>

</style>